import React, { useEffect, useRef, useState } from "react";
import Picker from "emoji-picker-react";
import classNames from "classnames";
import QuickReplyPicker from "./quick_reply_picker/quick_reply_picker.js";
import ImagePicker from "./image_picker/image_picker.js";
import { Tooltip } from "@blueprintjs/core";
import SessionStorageUtilities from "../../Utilities/SessionStorageUtilities";
import DocsPicker from "./docs_picker/docs_picker.js";
import Endpoints from "../../endpoints.js";
import Agente from "../../models/Agente.js";

/**
 *
 * @param {Object} props
 * @param {Agente} props.currentAgent
 * @returns {JSX.Element}
 * @constructor
 */
function InputArea(props) {
  let inputBox = useRef(null);
  //eslint-disable-next-line
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const [toggleEmoji, setToggleEmoji] = useState(false);
  const [toggleQuickRep, setToggleQuickRep] = useState(false);
  const [toggleImages, setToggleImages] = useState(false);
  const [toggleDocs, setToggleDocs] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showFileMenu, setShowFileMenu] = useState(false);
  const [uploadErrors, setUploadErrors] = useState(null);

  const klass = classNames({
    hide: !toggleEmoji,
  });

  const klassQuickRep = classNames({
    hide: !toggleQuickRep,
  });

  const closePicker = () => {
    setToggleEmoji(false);
  };

  const closeQuickRep = () => {
    setToggleQuickRep(false);
  };

  const closeImagePicker = () => {
    setToggleImages(false);
  };

  const closeDocsPicker = () => {
    setToggleDocs(false);
  };

  //document.body.addEventListener('click', this.closeDropdown.bind(this));

  const toggleEmojiPicker = () => {
    closeQuickRep();
    setToggleEmoji(!toggleEmoji);
  };

  const toggleQuickRepList = () => {
    closePicker();
    setToggleQuickRep(!toggleQuickRep);
  };

  const toggleImageList = () => {
    setToggleImages(true);
    setShowFileMenu(false);
  };

  const toggleDocsList = () => {
    setToggleDocs(true);
    setShowFileMenu(false);
  };

  const toggleFileMenu = () => {
    setShowFileMenu(!showFileMenu);
  };

  const onEmojiClick = (event, emojiObject) => {
    setChosenEmoji(emojiObject);
    inputBox.current.value = inputBox.current.value + emojiObject.emoji;
  };

  const onImageClick = (text, link) => {
    if (inputBlocked) return;
    var db = window.firebase.database(window.app2);
    const tenantDB = SessionStorageUtilities.GET_TENANT_SESSION();
    
    // Sanitizar también la URL de la imagen
    const sanitizedLink = sanitizeUrl(link);
    
    db.ref("mensajeSaliente/")
      .child(uuidv4())
      .set({
        to: props.receiver,
        type: "image",
        org: tenantDB,
        recipient_type: "individual",
        image: {
          link: sanitizedLink,
          caption: text,
        },
        br_agent: props.currentAgent.usuario.emailreal.replace(/\./g, " "),
      });
    closeImagePicker();
  };

  const uploadDocument = async (selectedFile) => {
    if (inputBlocked) return;
    try {
      const formData = new FormData();
      formData.append("files", selectedFile);
      formData.append(
        "upload_path",
        "clientcontent/" + props.receiver + "/sends/",
      );
      formData.append("group_id", props.currentAgent.usuario.grupo);

      const response = await fetch(Endpoints().UPLOADER_FILES_URL(), {
        method: "POST",
        headers: {
          Authorization:
            "Bearer " + props.currentAgent.stsTokenManager.accessToken,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Error al cargar el archivo: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error al cargar el archivo:", error);
      throw error;
    }
  };

  const sendDocumentMessage = (fileUrl, fileName) => {
    if (inputBlocked) return;
    var db = window.firebase.database(window.app2);
    const tenantDB = SessionStorageUtilities.GET_TENANT_SESSION();
    
    // Asegurar que la URL esté completamente sanitizada antes de enviar
    const finalUrl = sanitizeUrl(fileUrl);
    
    db.ref("mensajeSaliente/")
      .child(uuidv4())
      .set({
        to: props.receiver,
        type: "document",
        org: tenantDB,
        recipient_type: "individual",
        document: {
          link: finalUrl,
          filename: fileName,
        },
        br_agent: props.currentAgent.usuario.emailreal.replace(/\./g, " "),
      });
  };

  // Función mejorada para sanitizar URLs compatible con WhatsApp
  const sanitizeUrl = (url) => {
    if (!url) return url;

    try {
      // Método 1: Usar encodeURI que es más compatible con WhatsApp
      // encodeURI codifica espacios como %20 pero mantiene caracteres válidos de URL
      let sanitizedUrl = url;
      
      // Si la URL tiene espacios u otros caracteres no permitidos
      if (/[\s\u00C0-\u017F]/.test(url)) {
        // Separar la URL en componentes
        const urlMatch = url.match(/^(https?:\/\/)([^\/]+)(\/.*)$/);
        
        if (urlMatch) {
          const [, protocol, domain, path] = urlMatch;
          
          // Decodificar el path primero para evitar doble codificación
          let decodedPath = path;
          try {
            decodedPath = decodeURIComponent(path);
          } catch (e) {
            // Si falla, usar el path original
            decodedPath = path;
          }
          
          // Codificar cada parte del path por separado
          const encodedPath = decodedPath
            .split('/')
            .map(segment => {
              if (!segment) return segment;
              // Usar encodeURIComponent y luego reemplazar algunos caracteres
              // que WhatsApp acepta pero encodeURIComponent codifica
              return encodeURIComponent(segment)
                .replace(/!/g, '!')
                .replace(/'/g, "'")
                .replace(/\(/g, '(')
                .replace(/\)/g, ')')
                .replace(/\*/g, '*');
            })
            .join('/');
          
          sanitizedUrl = protocol + domain + encodedPath;
        } else {
          // Fallback: usar encodeURI completo
          sanitizedUrl = encodeURI(url);
        }
      }
      
      // Validar que la URL resultante sea válida
      new URL(sanitizedUrl);

      return sanitizedUrl;
      
    } catch (error) {
      console.error("Error al sanitizar URL:", error);
      // Último intento: usar encodeURI simple
      try {
        const encoded = encodeURI(url);
        return encoded;
      } catch (e) {
        console.error("Error en fallback:", e);
        return url;
      }
    }
  };

  const onDocumentClick = (selectedFile, upload = true) => {
    if (inputBlocked) return;
    if (upload) {
      uploadDocument(selectedFile)
        .then((data) => {
          if (data.success === true) {
            if (data && data.files && data.files.length > 0) {
              const fileInfo = data.files[0];
              
              // Sanitizar la URL antes de enviar
              const sanitizedUrl = sanitizeUrl(fileInfo.public_url);
              sendDocumentMessage(sanitizedUrl, fileInfo.file_name);
              closeDocsPicker();
            }
          } else {
            console.error("Error al subir el documento:", data);
            setUploadErrors(
              data.files[0].error_message ||
                "Error desconocido al subir el documento.",
            );
          }
        })
        .catch((error) => {
          console.error("Error en la subida del documento:", error);
          setUploadErrors(
            error.message || "Error desconocido al subir el documento.",
          );
        });
    } else {
      // Sanitizar la URL del documento predefinido
      const sanitizedUrl = sanitizeUrl(selectedFile.link);
      sendDocumentMessage(sanitizedUrl, selectedFile.filename);
      closeDocsPicker();
    }
  };

  const handleEnter = (e) => {
    if (inputBlocked) return;
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Prevenir el salto de línea
      postMessage();
    }
  };

  const handleClick = () => {
    if (inputBlocked) return;
    postMessage();
  };

  const cloneReply = (replyText) => {
    if (inputBlocked) return;
    inputBox.current.value = replyText;
    closeQuickRep();
  };

  const uuidv4 = () => {
    //eslint-disable-next-line
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16),
    );
  };

  const postMessage = () => {
    if (inputBlocked) return;
    let body = inputBox.current.value.trim();

    const tenantDB = SessionStorageUtilities.GET_TENANT_SESSION();
    if (body !== "") {
      inputBox.current.value = ""; // Limpiar el campo de entrada
      var db = window.firebase.database(window.app2);
      db.ref("mensajeSaliente/")
        .child(uuidv4())
        .set({
          to: props.receiver,
          type: "text",
          org: tenantDB,
          recipient_type: "individual",
          text: {
            body: body,
          },
          br_agent: props.currentAgent.usuario.emailreal.replace(/\./g, " "),
        });
    }
    // Reenfocar el campo de entrada
    inputBox.current.focus();
  };

  const contact = props.contactList.find((c) => c.id === props.receiver);
  let conversationIsExpired = false;
  if (contact && contact.hasOwnProperty("lastMessage")) {
    const timestamp = Math.max(contact.lastMessage.Inbound.Timestamp, 1) * 1000;
    conversationIsExpired = new Date().getTime() - timestamp > 86400000;
  }
  const inputBlocked = conversationIsExpired || props.blockedByOwnership;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <div
      className="d-flex justify-self-end align-items-center flex-row"
      id="input-area"
    >
      <div>
        {/* <Tooltip content="Emojis"> */}
        <i
          className={`far fa-smile px-3 ${inputBlocked ? "text-disabled" : "text-muted"}`}
          style={{
            fontSize: "1.5rem",
            cursor: inputBlocked ? "not-allowed" : "pointer",
            opacity: inputBlocked ? 0.5 : 1,
          }}
          onClick={inputBlocked ? undefined : toggleEmojiPicker}
        ></i>
        {/* </Tooltip> */}
        <div className={klass} onBlur={closePicker}>
          <Picker
            onEmojiClick={onEmojiClick}
            preload={false}
            groupVisibility={{
              smileys_people: true,
              animals_nature: false,
              food_drink: false,
              travel_places: false,
              activities: false,
              objects: false,
              symbols: false,
              flags: false,
            }}
          />
        </div>
      </div>
      <div>
        <Tooltip content="Respuestas rápidas">
          <i
            className={`far fa-clone px-3 ${inputBlocked ? "text-disabled" : "text-muted"}`}
            style={{
              fontSize: "1.5rem",
              cursor: inputBlocked ? "not-allowed" : "pointer",
              opacity: inputBlocked ? 0.5 : 1,
            }}
            onClick={inputBlocked ? undefined : toggleQuickRepList}
          ></i>
        </Tooltip>
        <div className={klassQuickRep} onBlur={closeQuickRep}>
          <aside className="input-picker">
            <QuickReplyPicker
              cloneReply={cloneReply}
              quickReplies={props.quickReplies}
              typification={props.typification}
            />
          </aside>
        </div>
      </div>
      <textarea
        disabled={inputBlocked}
        ref={inputBox}
        type="text"
        name="message"
        placeholder="Escribe un mensaje"
        className="flex-grow-1 border-0 px-3 py-2 my-3 rounded shadow-sm"
        onKeyPress={handleEnter}
      />
      {isMobile ? (
        <div style={{ position: "relative" }}>
          <Tooltip content="Archivos">
            <i
              className={`px-3 ${inputBlocked ? "text-disabled" : "text-muted"}`}
              style={{
                fontSize: "1.5rem",
                cursor: inputBlocked ? "not-allowed" : "pointer",
                opacity: inputBlocked ? 0.5 : 1,
              }}
              onClick={inputBlocked ? undefined : toggleFileMenu}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="currentColor"
                className="bi bi-paperclip"
                viewBox="0 0 16 16"
              >
                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
              </svg>
            </i>
          </Tooltip>
          {showFileMenu && !inputBlocked && (
            <div
              style={{
                position: "absolute",
                bottom: "100%",
                right: 0,
                backgroundColor: "white",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                borderRadius: "8px",
                padding: "8px 0",
                marginBottom: "8px",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  padding: "12px 20px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
                onClick={toggleImageList}
              >
                <i className="far fa-images" style={{ fontSize: "1.2rem" }}></i>
                <span>Imágenes</span>
              </div>
                <div
                  style={{
                    padding: "12px 20px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                  onClick={toggleDocsList}
                >
                  <i
                    className="far fa-file-alt"
                    style={{ fontSize: "1.2rem" }}
                  ></i>
                  <span>Documentos</span>
                </div>
            </div>
          )}
        </div>
      ) : (
        <>
          <div>
            <Tooltip content="Imágenes">
              <i
                className={`far fa-images px-3 ${inputBlocked ? "text-disabled" : "text-muted"}`}
                style={{
                  fontSize: "1.5rem",
                  cursor: inputBlocked ? "not-allowed" : "pointer",
                  opacity: inputBlocked ? 0.5 : 1,
                }}
                onClick={inputBlocked ? undefined : toggleImageList}
              ></i>
            </Tooltip>
          </div>
            <div>
              <Tooltip content="Documentos">
                <i
                  className={`far fa-file-alt px-3 ${inputBlocked ? "text-disabled" : "text-muted"}`}
                  style={{
                    fontSize: "1.5rem",
                    cursor: inputBlocked ? "not-allowed" : "pointer",
                    opacity: inputBlocked ? 0.5 : 1,
                  }}
                  onClick={inputBlocked ? undefined : toggleDocsList}
                ></i>
              </Tooltip>
            </div>
        </>
      )}
      <Tooltip content="Enviar">
        <i
          className={`fas fa-paper-plane px-3 ${inputBlocked ? "text-disabled" : "text-muted"}`}
          style={{
            cursor: inputBlocked ? "not-allowed" : "pointer",
            fontSize: "1.5rem",
            opacity: inputBlocked ? 0.5 : 1,
          }}
          onClick={inputBlocked ? undefined : handleClick}
        ></i>
      </Tooltip>
      <ImagePicker
        isOpen={toggleImages}
        close={closeImagePicker}
        onImageClick={onImageClick}
        quickReplies={props.quickReplies}
      />

      <DocsPicker
        isOpen={toggleDocs}
        close={closeDocsPicker}
        onDocumentClick={onDocumentClick}
        uploadErrors={uploadErrors}
        currentAgent={props.currentAgent}
        quickReplies={props.quickReplies}
      />
    </div>
  );
}

export default InputArea;
